import { render, staticRenderFns } from "./NodeFieldTemplate.vue?vue&type=template&id=81702e3c&scoped=true&"
import script from "./NodeFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./NodeFieldTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81702e3c",
  null
  
)

export default component.exports